// extracted by mini-css-extract-plugin
export default {"p_tye":"_27c5e89f5d","slcted":"_071d8b8fc8","slc_color":"ffa3319e47","item_p":"_7ceb6fb870","r0":"_04e4a7181d"};